module.exports = __webpack_public_path__ + "images/5c36020bb41bc1f582762e0bb4caf78b.png";